import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import {number_format,number_input_format} from './helper/format';

class Popup extends Component {
  constructor(props)
  {
    super(props);
    this.state = {
      open : false,
      _subsidy_price: 0,
      _promise_price: 0,
      _v1: 0,
      _v2: 0
    };
  }
  componentDidMount()
  {
    // this.setState({open:this.props.openState});
    // 요금제 가져오기
  }
  Open(subsidy_price, promise_price,v1,v2)
  {
    this.setState({
        open: true,
        _subsidy_price: subsidy_price,
        _promise_price: promise_price,
        _v1: v1,
        _v2: v2
    });
  }
  Close()
  {
    this.setState({
      open: false
    });
  }
  onCloseModal()
  {
    this.setState({ open: false });
  }
  Apply(type)
  {
    this.props.onSupportChanged(type);
    this.Close();
  }
  render()
  {
    var self = this;
    return (
      <Modal open={this.state.open} onClose={()=>{self.onCloseModal()}} center>
          <div className="modal-dialog modal-md">
            <div className="popupPadding3 pr10">
                <div className="md-popup-header"> &nbsp;지원금 비교</div>
                <div className="md-popup-contents pt0 pl0">
                    <table className="table priceGuideTable">
                        <thead>
                            <tr>
                                <th className="bgf5 br1 width180">지원금선택<br/>(24개월 기준)</th>
                                <th className="bgf5 br1">공통지원금</th>
                                <th className="bgf5">선택약정</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="bgf5 br1 width180">단말기<br/>구매비용지원</td>
                                <td className="br1">{number_input_format(self.state._subsidy_price)}원</td>
                                <td>-</td>
                            </tr>
                            <tr>
                                <td className="bgf5 br1 width180">요금할인</td>
                                <td className="br1 nonebottomborder">-</td>
                                <td className="nonebottomborder">월 {number_input_format(self.state._promise_price)}원</td>
                            </tr>
                            <tr>
                                <td className="bgf5 width180">총 할인금액<br/>(월 할인금액 x 약정기간)</td>
                                <td className="br1 redtop redtext redleft">{number_input_format(self.state._subsidy_price)}원</td>
                                <td className="redtop redtext redright">{number_input_format(self.state._promise_price*24)}원</td>
                            </tr>
                            <tr>
                                <td className="bgf5 width180">월 납부액</td>
                                <td className="br1 redleft redtext redbottom">{number_input_format(self.state._v1)}원</td>
                                <td className="redright redtext redbottom">{number_input_format(self.state._v2)}원</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>
                                  <a className="btn btn-default" onClick={()=>{self.Apply(1)}} href="#apply">공통지원금 적용</a>
                                </td>
                                <td>
                                  <a className="btn btn-default" onClick={()=>{self.Apply(2)}} href="#apply2">선택약정 적용</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
          </div>
      </Modal>
    ) ;
  }
}

export default Popup;

